import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { dateIsEqualOrIsAfterNextDay } from 'utils/validation';

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  accountName: yup
    .string()
    .required(t('validation.valueIsRequired'))
    .min(2, t('validation.invalid', { name: t('api_accounts.accountName') }))
    .matches(
      /^\S*$/,
      t('validation.invalid', { name: t('api_accounts.accountName') })
    ),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .typeError(t('validationDateInvalid', { name: t('validFrom') }))
      .default(null),
    to: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .nullable()
      .typeError(t('validationDateInvalid', { name: t('validTo') }))
      .default(null)
      .test(
        'isAfterStart',
        t('dateRangeMismatch', {
          startDate: t('validFrom'),
          endDate: t('validTo')
        }),
        dateIsEqualOrIsAfterNextDay
      )
  }),
  flags: yup.object({
    DISABLED: yup.boolean().default(false),
    LOCKED: yup.boolean().default(false)
  })
});
